import { useState } from 'react'
import { Comment, EmojiReaction } from '../types/feedItems'

export const useFeedInteractions = (initialReactions: EmojiReaction[] = [], initialComments: Comment[] = []) => {
  const [reactions, setReactions] = useState(initialReactions)
  const [comments, setComments] = useState(initialComments)

  const handleReactionAdd = (emoji: string) => {
    const updatedReactions = [...reactions]
    const existingReactionIndex = updatedReactions.findIndex((r) => r.emoji === emoji)

    if (existingReactionIndex >= 0) {
      const userReacted = updatedReactions[existingReactionIndex].userReacted
      if (userReacted) {
        updatedReactions[existingReactionIndex].count -= 1
        if (updatedReactions[existingReactionIndex].count === 0) {
          updatedReactions.splice(existingReactionIndex, 1)
        } else {
          updatedReactions[existingReactionIndex].userReacted = false
        }
      } else {
        updatedReactions[existingReactionIndex].count += 1
        updatedReactions[existingReactionIndex].userReacted = true
      }
    } else {
      updatedReactions.push({
        emoji,
        count: 1,
        userReacted: true,
      })
    }

    setReactions(updatedReactions)
  }

  const handleCommentAdd = (text: string) => {
    const newComment = {
      id: (comments.length || 0) + 1,
      user: {
        name: 'You',
        avatar: '/lovable-uploads/fbfda59b-9b28-42fb-be9c-053ee06992f8.png',
      },
      text,
      timestamp: 'Just now',
    }

    setComments([...comments, newComment])
  }

  return {
    reactions,
    comments,
    handleReactionAdd,
    handleCommentAdd,
  }
}
